import { getConfig } from '../environments';
import { BaseUrl, DesignToolsConfig, shopCodeType } from './config.schema';
class ConfigService {
  constructor(public config: DesignToolsConfig) {}

  getStage(): string {
    return this.config.stage;
  }

  getBaseUrl(shopCode = 'ex'): BaseUrl {
    return this.config.shops[shopCode as shopCodeType].baseUrl;
  }
}

const configService = new ConfigService(getConfig());
export default configService;
